import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import MuiFormControlLabel from '@mui/material/FormControlLabel';
import { useDataProps } from '@famly/mf_ts-utils_data-aria-props';
import { Text } from '@famly/mf_data-display_text';
import { Stack } from '@famly/mf_layout_stack';
import { useResponsiveSize } from '@famly/mf_util_breakpoints';
import { ToggleControl } from './toggle-control';
export const Toggle = (props) => {
    var _a, _b, _c, _d;
    const dataProps = useDataProps(props);
    const size = useResponsiveSize(props.size);
    const alignment = (_a = props.alignment) !== null && _a !== void 0 ? _a : (props.helperText ? 'top' : 'center');
    return (_jsx(MuiFormControlLabel, { control: _jsx(ToggleControl, { checked: props.checked, disabled: props.disabled, id: props.id, onChange: props.onChange, size: props.size }), label: _jsxs(Stack, { component: "span", direction: "column", gap: 0.5, children: [_jsx(Text, { color: props.disabled ? 'n300' : 'n400', component: "span", emphasized: (_b = props.labelEmphasized) !== null && _b !== void 0 ? _b : true, variant: (_c = props.labelVariant) !== null && _c !== void 0 ? _c : (size === 'regular' ? 'body' : 'body-small'), children: props.label }), props.helperText ? (
                // Line breaks in a helper string are meaningful: settings copy uses them for
                // fee lists and similar, and collapsing them runs the lines together.
                _jsx(Text, { color: "n300", component: "span", variant: "micro", whiteSpace: "pre-line", children: props.helperText })) : null] }), labelPlacement: (_d = props.labelPlacement) !== null && _d !== void 0 ? _d : 'start', sx: theme => ({
            alignItems: alignment === 'top' ? 'flex-start' : 'center',
            columnGap: theme.spacing(3),
            margin: 0,
            ...(props.fullWidth ? { display: 'flex', justifyContent: 'space-between', width: '100%' } : {}),
            '& .MuiFormControlLabel-label': {
                minWidth: 0,
                wordBreak: 'break-word',
            },
            // A long label must wrap rather than squeeze the control out of shape.
            '& .MuiSwitch-root': {
                flexShrink: 0,
            },
        }), ...dataProps }));
};
